import FormAutoSuggestDropdown from './FormAutoSuggestDropdown';
import FormAutoSuggestDropdownCheckbox from './FormAutoSuggestDropdownCheckbox';
import FormDatePickerNew from './FormDatePickerNew';
import FormTextField from './FormTextField';
import FormUploadSetImage from './FormUploadSetImage';
import FormUploadNew from './FormUploadNew';

const Export = {
  FormTextField,
  FormUploadSetImage,
  FormUploadNew,
  FormAutoSuggestDropdown,
  FormAutoSuggestDropdownCheckbox,
  FormDatePickerNew,
};

export default Export;
